import { Pipe, PipeTransform } from '@angular/core';
import { TipoEmpresa } from '../../models/auth/TipoEmpresa';

@Pipe({
  name: 'tipoEmpresa',
})
export class TipoEmpresaPipe implements PipeTransform {
  transform(tipoEmpresa: TipoEmpresa): string {
    return {
      [TipoEmpresa.Matriz]: 'Matriz',
      [TipoEmpresa.Filial]: 'Filial',
    }[tipoEmpresa];
  }
}
